import { render, staticRenderFns } from "./OfferProductBox.vue?vue&type=template&id=e9469f82&"
import script from "./OfferProductBox.vue?vue&type=script&lang=js&"
export * from "./OfferProductBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports